'use memo';

import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { type ComboboxTriggerWidth, resolveComboboxTriggerWidth } from './comboboxTriggerWidth';
type Props = {
  width?: ComboboxTriggerWidth;
  className?: string;
  children: ReactNode;
};

/**
 * Combobox トリガー用の幅ラッパー。
 * CForm カード内で `w-full` トリガーが横に伸びないよう `inline-block` + 既定 180px を付与する。
 */
export function ComboboxTriggerShell({
  width,
  className,
  children
}: Props) {
  const {
    shellClassName,
    shellStyle
  } = resolveComboboxTriggerWidth(width);
  return <div className={cn(shellClassName, className)} style={shellStyle}>
      {children}
    </div>;
}